import { Component, OnInit } from '@angular/core';
import { OrganizationConfig } from '../../../../../../models/organization-config';
import { AccountService } from '../../../../../../services/account/account.service';
import { OrganizationConfigService } from '../../../../../../services/organization-config/organization-config.service';


@Component({
  selector: 'app-org-wide-membership-settings',
  templateUrl: './org-wide-membership-settings.component.html',
  styleUrls: ['./org-wide-membership-settings.component.css']
})
export class OrgWideMembershipSettingsComponent implements OnInit {

  public orgConfig: OrganizationConfig;

  public loadingOrgConfig = true;
  public loadingSave = false;

  public successMessage = '';
  public errorMessage = '';
  public errors: any = {};
  public serverError: number = null;

  constructor(
    private accountService: AccountService,
    private orgConfigService: OrganizationConfigService
  ) {}

  ngOnInit() {
    this.loadOrganizationConfig();
  }

  /**
   * Load the organization config from the API.
   *
   * We do not use the local-stored copy, in order to avoid pop-in of changed
   * values.
   */
  public loadOrganizationConfig() {
    this.loadingOrgConfig = true;

    this.orgConfigService
      .loadOrganizationConfig()
      .then(() => {
        this.orgConfig = this.orgConfigService.getOrganizationConfig();

        const orgConfigServerError = this.orgConfigService.getOrganizationConfigServerError();
        if (orgConfigServerError) {
          this.serverError = orgConfigServerError;
        }
        this.loadingOrgConfig = false;
      });
  }

  public handleSave() {
    this.loadingSave = true;

    this.errors = {};
    this.errorMessage = '';

    this.orgConfigService
      .updateOrgConfig({
        failed_membership_cancellation_period_days: this.orgConfig.failed_membership_cancellation_period_days,
        send_recurring_membership_payment_confirmation_emails: this.orgConfig.send_recurring_membership_payment_confirmation_emails,
        send_membership_max_freeze_soon_emails: this.orgConfig.send_membership_max_freeze_soon_emails
      })
      .then(updatedOrgConf => {
        this.orgConfig = updatedOrgConf;
        this.successMessage = 'Settings updated successfully.';
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errors = reason.error;
          this.errorMessage = 'Please correct the errors above and try again.';
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to modify these settings.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSave = false; });
  }

}
